import React, { Component } from 'react';
import RothButton from '../components/RothButton.js';
import RothTextInput from '../components/RothTextInput.js';
import ReactModal from 'react-modal';

export default class CustomerPage extends Component {
  constructor() {
    super();
    this.state = {
      showModal: false,
    };

    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleModalYes = this.handleModalYes.bind(this);
    this.handleModalNo = this.handleModalNo.bind(this);
  }
  handleOpenModal() {
    this.setState({ showModal: true });
  }
  handleModalYes() {
    this.setState({ showModal: false });
    this.props.changePage('done');
  }
  handleModalNo() {
    this.setState({ showModal: false });
  }

  style = {};

  render = () => (
    <div className="content">
      <RothButton type="back" fn={this.props.changePage} param={this.props.backPage} value={this.props.backSubPage}>
        {'← ' + this.props.text('other', 'back')}
      </RothButton>
      <div className="inner">
        <div>
          <h1>{this.props.text('customer', 'h1')}</h1>
          <p>{this.props.text('customer', 'desc')}</p>
          <div style={{ padding: '20px 40px 0px 40px' }}>
            <RothTextInput param="projectName" value={this.props.customer.projectName} fn={this.props.changeCustomerParam}>
              {this.props.text('customer', 'i1')}
            </RothTextInput>
            <RothTextInput
              param="name"
              value={this.props.customer.name}
              placeholder={this.props.text('customer', 'placeholder')}
              fn={this.props.changeCustomerParam}
            >
              {this.props.text('customer', 'i2')}
            </RothTextInput>
            <RothTextInput
              param="address"
              value={this.props.customer.address}
              placeholder={this.props.text('customer', 'placeholder')}
              fn={this.props.changeCustomerParam}
            >
              {this.props.text('customer', 'i3')}
            </RothTextInput>
            <RothTextInput
              param="zip"
              value={this.props.customer.zip}
              placeholder={this.props.text('customer', 'placeholder')}
              fn={this.props.changeCustomerParam}
            >
              {this.props.text('customer', 'i4')}
            </RothTextInput>
            <RothTextInput
              param="city"
              value={this.props.customer.city}
              placeholder={this.props.text('customer', 'placeholder')}
              fn={this.props.changeCustomerParam}
            >
              {this.props.text('customer', 'i5')}
            </RothTextInput>
            <RothTextInput
              param="phone"
              value={this.props.customer.phone}
              placeholder={this.props.text('customer', 'placeholder')}
              fn={this.props.changeCustomerParam}
            >
              {this.props.text('customer', 'i6')}
            </RothTextInput>
            <RothTextInput
              param="email"
              value={this.props.customer.email}
              placeholder={this.props.text('customer', 'placeholder')}
              fn={this.props.changeCustomerParam}
            >
              {this.props.text('customer', 'i7')}
            </RothTextInput>
          </div>
        </div>
        <ReactModal
          isOpen={this.state.showModal}
          contentLabel=""
          style={{
            content: {
              position: 'absolute',
              top: '30%',
              width: 'calc(100% - 80px)',
              marginLeft: 'auto',
              marginRight: 'auto',
              height: '200px',
              border: '0px solid white',
              backgroundColor: this.props.constants.colorRed,
              borderRadius: '22px',
              padding: '40px 10px',
              maxWidth: '500px',
            },
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
            <div style={{ textAlign: 'center', color: 'white', fontSize: '30px', whiteSpace: 'pre-wrap' }}>
              {this.props.text('customer', 'areYouSure')}
            </div>
            <div style={{ textAlign: 'center' }}>
              <RothButton type="halfWhite" fn={this.handleModalYes}>
                {this.props.text('customer', 'yes')}
              </RothButton>
              <RothButton type="halfWhite" fn={this.handleModalNo}>
                {this.props.text('customer', 'no')}
              </RothButton>
            </div>
          </div>
        </ReactModal>
      </div>
      <RothButton disabled={!this.props.isPageAllowed('done')} type="wide" fn={this.handleOpenModal}>
        {this.props.text('customer', 'finish')}
      </RothButton>
    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./src/views/CustomerPage.js
 **/